// extracted by mini-css-extract-plugin
module.exports = {"root":"userForm_root__3uZqx","title":"userForm_title__3b5Wm","form":"userForm_form__1X8pQ","btnGroup":"userForm_btnGroup__3gMfi","btn":"userForm_btn__3h6Z9"};